import { Tooltip } from 'antd';
import { TooltipPropsWithTitle } from 'antd/lib/tooltip';
import TranslateText from 'components/hoc/TranslateText';
import React from 'react';

// https://ant.design/components/tooltip/#API
interface ITooltip extends TooltipPropsWithTitle {
    title: string;
}

const TooltipComponent: React.FC<ITooltip> = props => {
    const { title, ...rest } = props;
    return (
        <Tooltip {...rest} title={<TranslateText>{title}</TranslateText>}>
            {props.children}
        </Tooltip>
    );
};

export default TooltipComponent;
